import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useViewModeStore } from '@/stores/useViewModeStore';
import { ENTRY_VIEW_ROUTES, PLAIN_VIEW_ROUTES } from '@/constants/constants';
import { ViewMode } from '@/types/features';
import { matchesAny } from '@/utils/helpers/routeHelper';

export const useSyncViewMode = () => {
    const pathname = usePathname();
    const setViewMode = useViewModeStore((state) => state.setViewMode);

    useEffect(() => {
        if (matchesAny(ENTRY_VIEW_ROUTES, pathname)) {
            setViewMode('entry' as ViewMode);
        } else if (matchesAny(PLAIN_VIEW_ROUTES, pathname)) {
            setViewMode('plain' as ViewMode);
        } else {
            setViewMode('normal' as ViewMode);
        }
    }, [pathname, setViewMode]);
};
